import UpdateBadge from './UpdateBadge';

export default UpdateBadge;